/*  Scroll-triggered animations
    CSS hides elements immediately (opacity:0 via class selectors).
    JS reveals them with .anim-visible class when they enter viewport. */

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var rules = [
    /* Trust badge items */
    { sel: '.hv2-trust__item', stagger: true },

    /* Compare */
    { sel: '.hv2-compare__header' },
    { sel: '.hv2-compare__center' },
    { sel: '.hv2-compare__card', stagger: true },

    /* Products */
    { sel: '.hv2-products__centered-header' },
    { sel: '.hv2-products__header' },
    { sel: '.hv2-product-card', stagger: true },
    { sel: '.hv2-products__grid-wrap' },

    /* Sprinkle */
    { sel: '.hv2-sprinkle__header' },
    { sel: '.hv2-sprinkle__carousel' },

    /* Why */
    { sel: '.hv2-why__header' },
    { sel: '.hv2-why__item', stagger: true },

    /* UGC */
    { sel: '.hv2-ugc__header' },
    { sel: '.hv2-ugc__item', stagger: true },

    /* Nutritionist inner elements */
    { sel: '.hv2-nutritionist__stamp' },
    { sel: '.hv2-nutritionist__header' },
    { sel: '.hv2-nutritionist__author' },
    { sel: '.hv2-nutritionist__quote-wrap' },
    { sel: '.hv2-nutritionist__food-image' },
    { sel: '.hv2-nutritionist__right' },

    /* CTA */
    { sel: '.hv2-cta__content' },
    { sel: '.hv2-cta__image' },

    /* Footer */
    { sel: '.hv2-footer__left' },
    { sel: '.hv2-footer__menus' },

    /* PDP trust strip image */
    { sel: '.pdp2-trust-strip__image', speed: 'fast' },

    /* How it works */
    { sel: '.pdp2-how__heading' },
    { sel: '.pdp2-how__step', stagger: true },

    /* Features */
    { sel: '.pdp2-features__header' },
    { sel: '.pdp2-features__card', stagger: true },

    /* More protein */
    { sel: '.pdp2-more-protein__heading' },
    { sel: '.pdp2-more-protein__card', stagger: true },

    /* Loved */
    { sel: '.pdp2-loved__header' },
    { sel: '.pdp2-loved__item', stagger: true },

    /* Guarantee */
    { sel: '.pdp2-guarantee__badge' },
    { sel: '.pdp2-guarantee__heading' },
    { sel: '.pdp2-guarantee__desc' },
    { sel: '.pdp2-guarantee__btn' },

    /* FAQ */
    { sel: '.pdp2-faq__heading' },
    { sel: '.pdp2-faq__image' },
    { sel: '.pdp2-faq__list' },

    /* Reviews */
    { sel: '.pdp2-reviews__heading' },
    { sel: '.pdp2-reviews__widget' }
  ];

  /* Add stagger/speed classes */
  rules.forEach(function (rule) {
    if (!rule.stagger && !rule.speed) return;
    var els = document.querySelectorAll(rule.sel);
    var counter = 0;
    els.forEach(function (el) {
      if (rule.speed) el.classList.add('anim-fast');
      if (rule.stagger) {
        el.classList.add('anim-delay-' + (counter + 1));
        counter++;
        if (counter > 7) counter = 0;
      }
    });
  });

  /* IntersectionObserver reveals elements */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('anim-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
  );

  /* Collect all animated selectors */
  var allSels = rules.map(function (r) { return r.sel; }).join(',');
  var allEls = document.querySelectorAll(allSels);

  /* Immediately reveal elements already in viewport (avoids above-fold glitch) */
  var winH = window.innerHeight || document.documentElement.clientHeight;
  allEls.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.top < winH && rect.bottom > 0) {
      el.classList.add('anim-visible');
    } else {
      observer.observe(el);
    }
  });
});
